module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p24-25.1f784035.jpg";